import { render } from "./folder_tree.html?vue&type=template&id=04b626fb&external"
import script from "./folder_tree.js?vue&type=script&lang=js&external"
export * from "./folder_tree.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__